/**
 * Prerender detection.
 *
 * `scripts/prerender/prerender.js` sets `window.__PRERENDER__ = true` via
 * Puppeteer's evaluateOnNewDocument, which runs before any application code
 * on the page. So this is reliable, not a heuristic.
 *
 * Use it to suppress side effects that must not run once per generated page —
 * writes, analytics, polling. Do NOT use it to skip the *reads* that produce
 * page content: those are exactly what we want the prerenderer to capture.
 */
export function isPrerendering() {
  return typeof window !== "undefined" && window.__PRERENDER__ === true;
}

export default isPrerendering;
